if (!customElements.get('hb-scolaire-jeux-video')) {
  customElements.define('hb-scolaire-jeux-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.tabs = Array.from(this.querySelectorAll('[data-hbsjv-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-hbsjv-panel]'));
      if (!this.panels.length) return;
      this.ready = true; this.setAttribute('data-enhanced', '');
      this.querySelector('[data-hbsjv-tabs]')?.setAttribute('role', 'tablist');
      this.preservePreviewLinks();
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
      });
      this.dialog = this.querySelector('dialog');
      this.dialog.addEventListener('close', () => this.opener?.focus());
      this.querySelector('[data-hbsjv-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-hbsjv-modal-add]').addEventListener('click', () => { this.dialog.close(); this.cartForm?.requestSubmit(); });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-hbsjv-filter]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submitFilters(form);
      }, true);
      this.addEventListener('change', event => {
        const field = event.target.closest('[data-hb-param]');
        const form = field?.closest('[data-hbsjv-filter]');
        if (!form) return;
        event.stopImmediatePropagation();
        this.submitFilters(form);
      }, true);
      if (this.tabs.length) this.activate(Math.max(0, this.panels.findIndex(panel => panel.dataset.hbCollectionCount !== '0')));
      else {
        const panel = this.panels[0];
        const results = panel.querySelector('[data-hbsjv-results]');
        panel.loaded = !!results;
        panel.featured = results?.dataset.featured === 'true';
        panel.featuredTags = results?.dataset.featuredTags || '';
        panel.appliedURL = location.href;
      }
      this.addEventListener('click', event => {
        const quick = event.target.closest('[data-hbsjv-quick]');
        if(quick) {
          this.opener = quick;
          const card = quick.closest('.hbsjv-product');
          this.querySelector('[data-hbsjv-dialog-content]').replaceChildren(card.querySelector('template').content.cloneNode(true));
          this.cartForm = card.querySelector('form');
          this.querySelector('[data-hbsjv-modal-add]').hidden = !this.cartForm;
          this.dialog.showModal(); return;
        }
        const more = event.target.closest('[data-hbsjv-next]');
        if(more) {event.preventDefault(); this.load(more.closest('[data-hbsjv-panel]'), new URL(more.href), true);return;}
        const reset = event.target.closest('[data-hbsjv-reset]');
        if(reset) {event.preventDefault();this.load(reset.closest('[data-hbsjv-panel]'),new URL(reset.href));return;}
        const tab = event.target.closest('[data-hbsjv-tab]');
        if (!tab || !this.contains(tab)) return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        this.activate(index);
        this.panels[index].scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (event.key === ' ') next = index;
        if (next === undefined) return;
        event.preventDefault(); this.activate(next); this.tabs[next].focus();
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.hbsjvTab === event.detail.blockId);
        if (index >= 0) this.activate(index);
      });
    }
    preservePreviewLinks() {
      const theme = window.Shopify?.theme;
      const preview = new URL(location.href).searchParams.get('preview_theme_id') ||
        (theme?.id && theme.role && theme.role !== 'main' ? String(theme.id) : '');
      for (const link of this.querySelectorAll('[data-hbsjv-full], .hbsjv-back a, .hb-shared-banner__universe[href], .hb-shared-banner__back[href]')) {
        const url = new URL(link.href, location.origin);
        if (url.origin !== location.origin) continue;
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.href;
      }
    }
    disconnectedCallback() {
      this.panels?.forEach(panel => {panel.request?.abort();panel.loading=false;});
    }
    submitFilters(form) {
      const panel = form.closest('[data-hbsjv-panel]');
      if (!panel || !form.reportValidity()) return;
      // Start from the selected collection, never from an app-modified form URL.
      const url = new URL(panel.dataset.collectionUrl, location.origin);
      url.search = '';
      for (const field of form.querySelectorAll('[data-hb-param]')) {
        if (!field.disabled && field.value !== '') {
          url.searchParams.set(field.dataset.hbParam, field.value);
        }
      }
      this.load(panel, url);
    }
    setStatus(panel, text, error = false) {
      const status = panel.querySelector('[data-hbsjv-status]');
      status.textContent = text;
      status.dataset.error = String(error);
    }
    async load(panel, requestedURL, append = false) {
      if (!panel || !requestedURL || requestedURL.origin !== location.origin) return;
      if (append && panel.loading) return;
      let url = new URL(requestedURL);
      if (append && panel.appliedURL) {
        url = new URL(panel.appliedURL);
        for (const [key, value] of requestedURL.searchParams) {
          if (key === 'page' || key.startsWith('page_')) url.searchParams.set(key, value);
        }
      }
      // Do not keep obsolete filters from old links or pagination URLs.
      const supportedFilters = new Set(['filter.v.availability', 'filter.p.m.custom.licence', 'filter.p.m.custom.licences', 'filter.p.tag']);
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.') && !supportedFilters.has(key)) url.searchParams.delete(key);
      }
      const featured = append ? panel.featured === true : url.searchParams.get('sort_by') === 'hb-featured';
      url.searchParams.delete('view');
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', 'hb-scolaire-jeux-video-results');
      if (featured) {
        url.searchParams.set('sort_by', 'manual');
        url.searchParams.set('filter.p.tag', panel.featuredTags || 'Crush');
      } else {
        url.searchParams.delete('filter.p.tag');
      }
      if (!append) {
        for (const key of [...url.searchParams.keys()]) {
          if (key === 'page' || key.startsWith('page_')) url.searchParams.delete(key);
        }
      }
      // The editor iframe can omit preview_theme_id from its URL.
      // Keep the currently viewed draft on every request, without pinning the live store.
      const theme = window.Shopify?.theme;
      const preview = new URL(location.href).searchParams.get('preview_theme_id') ||
        (theme?.id && theme.role && theme.role !== 'main' ? String(theme.id) : '');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      else url.searchParams.delete('preview_theme_id');
      panel.request?.abort();
      const controller = new AbortController();
      panel.request = controller;
      panel.loading = true;
      panel.setAttribute('aria-busy', 'true');
      this.setStatus(panel, 'Chargement des produits…');
      try {
        const response = await (window.HBCollectionRequests?.fetch.bind(window.HBCollectionRequests) || fetch)(url, {
          signal: controller.signal,
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {'Accept': 'text/html'}
        });
        if (!response.ok) throw new Error('Le chargement des produits a échoué.');
        const responseHTML = await response.text();
        const doc = new DOMParser().parseFromString(responseHTML, 'text/html');
        if (controller.signal.aborted || panel.request !== controller) return;
        const results = doc.querySelector('[data-hbsjv-results]');
        if (!results || results.dataset.hbFiltersVersion !== '2') {
          throw new Error(window.Shopify?.designMode
            ? 'Le fichier hb-scolaire-jeux-video-results.liquid corrigé n’a pas été chargé dans ce thème.'
            : 'Le chargement des produits est indisponible pour le moment.');
        }
        const actualPath = new URL(results.dataset.collectionUrl, location.origin).pathname;
        if (actualPath !== url.pathname) throw new Error('La collection reçue ne correspond pas à la sélection.');
        const wantedSort = url.searchParams.get('sort_by');
        if (wantedSort && results.dataset.currentSort !== wantedSort) {
          throw new Error('Le tri demandé n’a pas été appliqué.');
        }
        if ((results.dataset.featured === 'true') !== featured) {
          throw new Error(window.Shopify?.designMode
            ? 'Le filtre Coup de cœur n’a pas été appliqué. Vérifiez le filtre Balises dans Search & Discovery.'
            : 'Le filtre Coup de cœur n’a pas pu être appliqué.');
        }
        // Reject a response that silently dropped availability or licence.
        for (const key of ['filter.v.availability', 'filter.p.m.custom.licence', 'filter.p.m.custom.licences']) {
          const expected = url.searchParams.get(key) || '';
          const field = results.querySelector('[data-hb-param="' + key + '"]');
          const actual = field?.value || '';
          const matches = expected === actual;
          if (!matches) throw new Error('Les filtres demandés n’ont pas été appliqués.');
        }
        window.HBCollectionRequests?.remember(url, responseHTML);
        const host = panel.querySelector('[data-hbsjv-host]');
        if (append && host.querySelector('[data-hbsjv-results]')) {
          host.querySelector('.hbsjv-products').append(...results.querySelectorAll('.hbsjv-product'));
          const oldMore = host.querySelector('.hbsjv-load');
          const newMore = results.querySelector('.hbsjv-load');
          if (oldMore && newMore) oldMore.replaceWith(newMore);
          else oldMore?.remove();
        } else {
          host.replaceChildren(results);
        }
        panel.loaded = true;
        panel.featured = featured;
        if (results.dataset.featuredTags) panel.featuredTags = results.dataset.featuredTags;
        panel.appliedURL = url.href;
        if (!this.tabs.length && !append && new URL(location.href).pathname === url.pathname) {
          const visibleURL = new URL(url);
          visibleURL.searchParams.delete('section_id');
          visibleURL.searchParams.set('view', 'hb-scolaire-jeux-video');
          history.replaceState(history.state, '', visibleURL);
        }
        const count = host.querySelectorAll('.hbsjv-product').length;
        this.setStatus(panel, count + ' produit(s) affiché(s).');
      } catch (error) {
        if (error.name !== 'AbortError' && panel.request === controller) {
          // Preserve the user's requested fields and say explicitly the old grid remains.
          this.setStatus(panel, error.message + ' Les résultats précédents restent affichés. Cliquez sur Appliquer pour réessayer.', true);
        }
      } finally {
        if (panel.request === controller) {
          panel.loading = false;
          panel.removeAttribute('aria-busy');
        }
      }
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
        const panel=this.panels[i];
        if(i===index && panel.dataset.collectionUrl && !panel.loaded && !panel.loading) this.load(panel,new URL(panel.dataset.collectionUrl,location.origin));
      });
    }
  });
}
